module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-d8e9afd431270ac2fb2a79238601c344.svg";